var render = function render(){var _vm=this,_c=_vm._self._c;return _c('page-edicion',[_c('page-header',{attrs:{"title":"Crear origen de oferta","back-to":"/origenOferta"}}),_c('formulario',{attrs:{"origen-oferta":_vm.origenOferta},on:{"submit":_vm.insertar}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }